export enum Team {
  CARE,
  SALES,
  MYVM,
}
